import "./App.css";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddKirtanStepper from "./Components/Pages/AddKirtan";
import SearchPage from "./Components/Pages/SearchPage";
import KirtanArea from "./Components/Pages/KirtanArea";
import DatabaseForm from "./Components/Pages/DatabaseForm";
import IndexedDBService, { tblMySettings, keyboardSettings, VMixButtonApiSetting } from "./Utils/DBConfig";
import PreSetting from "./Utils/PreSetting.json";
import KeyboardButton from "./Utils/keyboardButton.json";
import VMixButton from "./Utils/VMixButton.json";
import Manglacharan from "./Components/Pages/Manglacharan";
import Converter from "./Components/Pages/Converter";
import { setDbStatus } from "./Slice/dbSlice";
import { setPreSettings } from "./Slice/settingsSlice";
import { setKeyboardKeys } from "./Slice/keyBoardSlice";
import KeyboardApiEdit from "./Components/Pages/KeyboardApiEdit";
import LoginPage from "./Components/Pages/LoginPage";
import { PublicRoutes } from "./Utils/PublicRoutes";
import { ProtectedRoute } from "./Utils/ProtectedRoutes";
import { setVMixZoomButton } from "./Slice/vMixZoomSlice";
import VMixZoomSetting from "./Components/Pages/VMixZoomSetting";

function App() {
  const dispatch = useDispatch();
  let settings = localStorage.getItem("vmixSettings");
  if (!settings) {
    localStorage.setItem("vmixSettings", JSON.stringify({
      webControllerUrl: "http://127.0.0.1:8088",
      overlayChannelId: 2,
      inputId: "ICG",
      input: "",
      manualMode: false,
      selectedName1: "line1.Text",
      selectedName2: "line2.Text",
    }));
  }

  useEffect(() => {
    IndexedDBService.initDB()
      .then(() => {
        dispatch(setDbStatus(true));
        const transaction = IndexedDBService.db.transaction(
          [tblMySettings],
          "readwrite"
        );
        const objectStore = transaction.objectStore(tblMySettings);
        const countRequest = objectStore.count();

        countRequest.onsuccess = function () {
          const count = countRequest.result;
          if (count === 0) {
            PreSetting.forEach((setting) => {
              let obj = {};
              obj = { ...setting };
              IndexedDBService.addItem(obj, tblMySettings)
                .then(() => { })
                .catch(() => { })
                .finally(() => { dispatch(setPreSettings(PreSetting)); });
            });
          }
        };


        const transactionKeyboardSettings = IndexedDBService.db.transaction(
          [keyboardSettings],
          "readwrite"
        );
        const objectStoreKeyboardSettings = transactionKeyboardSettings.objectStore(keyboardSettings);
        const countRequestKeyboardSettings = objectStoreKeyboardSettings.count();

        countRequestKeyboardSettings.onsuccess = function () {
          const countKeyboardSettings = countRequestKeyboardSettings.result;
          if (countKeyboardSettings === 0) {
            KeyboardButton.forEach((button) => {
              let obj = { ...button };
              IndexedDBService.addItem(obj, keyboardSettings)
                .then(() => { })
                .catch(() => { })
                .finally(() => { });
            });
          }
        };


        const transactionVMixButtonApiSetting = IndexedDBService.db.transaction(
          [VMixButtonApiSetting],
          "readwrite"
        );
        const objectStoreVMixButtonApiSetting = transactionVMixButtonApiSetting.objectStore(VMixButtonApiSetting);
        const countRequestVMixButtonApiSetting = objectStoreVMixButtonApiSetting.count();

        countRequestVMixButtonApiSetting.onsuccess = function () {
          const countVMixButtonApiSetting = countRequestVMixButtonApiSetting.result;
          if (countVMixButtonApiSetting === 0) {
            VMixButton.forEach((button) => {
              let obj = { ...button };
              IndexedDBService.addItem(obj, VMixButtonApiSetting)
                .then(() => { })
                .catch(() => { })
                .finally(() => { });
            });
          }
        };


        IndexedDBService.getAllData(tblMySettings)
          .then((data) => dispatch(setPreSettings(data)))
          .catch((error) => console.error(error));

        IndexedDBService.getAllData(keyboardSettings)
          .then((data) => dispatch(setKeyboardKeys(data)))
          .catch((error) => console.error(error));

        IndexedDBService.getAllData(VMixButtonApiSetting)
          .then((data) => dispatch(setVMixZoomButton(data)))
          .catch((error) => console.error(error));
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/edit/:id" element={<ProtectedRoute><AddKirtanStepper /></ProtectedRoute>} />
          <Route path="/input" element={<ProtectedRoute><AddKirtanStepper /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><KirtanArea /></ProtectedRoute>} />
          <Route path="/kirtan-data" element={<ProtectedRoute><DatabaseForm /></ProtectedRoute>} />
          <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
          <Route path="/manglacharan" element={<ProtectedRoute><Manglacharan /></ProtectedRoute>} />
          <Route path="/keyboardEdit" element={<ProtectedRoute><KeyboardApiEdit /></ProtectedRoute>} />
          <Route path="/converter" element={<ProtectedRoute><Converter /></ProtectedRoute>} />
          <Route path="/zoom" element={<ProtectedRoute><VMixZoomSetting /></ProtectedRoute>} />
          <Route path="/login" element={<PublicRoutes><LoginPage /></PublicRoutes>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
